import { cssColorValue, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Indicator = styled.span.withConfig({
  displayName: "Indicator",
  componentId: "sc-acu4qz-0"
})(["background:", ";border-radius:inherit;block-size:12px;position:absolute;top:2px;inline-size:12px;transition:all 0.1s ease;"], cssColorValue(semanticColors.backgroundBase));